<template>
  <modal @onCancel="$emit('onCancel')">
    <template #title v-if="! pending && ! idAustriaIframeUrl && ! smartidentInitiated">
      <p class="rtl:text-right">
        Wie möchten Sie unterzeichnen?
      </p>
    </template>

    <template #description>
      <template v-if="! smartidentInitiated">
        <div class="py-12" v-if="pending">
          <Loader
            :show-text="false"
            class="-mt-4 text-neutral-4"
          />
        </div>

        <p v-if="error" class="mt-4 mb-4 border border-red-5 border-red p-3 text-red-3 font-medium rounded-md bg-red-10">
          {{ error == 'access_denied' ? 'Sie haben den Prozess abgebrochen.' : 'Es ist ein Fehler aufgetreten.' }}
        </p>
        
        <div class="flex items-centerX space-x-4 mb-4" v-if="! pending && ! idAustriaIframeUrl">
          <button v-if="allowedTypes.includes('id_austria')" @click="onInitiateIdAustria" type="button" class="flex-1 flex items-center justify-center rounded-md border border-neutral-8 outline-none ring-0 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 1800 560" class="h-20 w-auto"><path d="M1594.7 255.5c-16.7 0-31.5 7.3-31.5 7.3l6.6 16.7s12.3-5.9 23.9-5.9c7.1 0 17.2 3.4 17.2 13.8v4.5s-7.6-5.7-22.3-5.7c-17.4 0-31.4 11.1-31.4 26.5 0 17 13.8 26.8 28.8 26.8 18 0 26.3-12.1 26.3-12.1v10.1h18.7v-52.1c.2-18.3-13.3-29.9-36.3-29.9m-2.3 67.1c-6.2 0-14.5-1.9-14.5-10.3 0-8.6 8.6-11.3 14.8-11.3 11 0 18.2 4 18.2 4v8.3s-6.4 9.3-18.5 9.3m-81.6-90.9c0 7.4 5.9 13.3 13.3 13.3s13.3-5.9 13.3-13.3-5.9-13.3-13.3-13.3-13.3 5.9-13.3 13.3m3.2 105.7h20.2v-79.9H1514v79.9zm-30.9-81.9c-14.8 0-21.8 13.7-21.8 13.7v-11.6h-19.2v79.9h20.2v-52.3s5.6-10.8 17.9-10.8c5.9 0 9.6 1.9 9.6 1.9l7.1-18.2c0-.1-6.6-2.6-13.8-2.6m-120.9 20.2h15.7v35.4c0 17 11.8 28.3 27.3 28.3 11.6 0 19.2-5.2 19.2-5.2l-7.4-16.5s-3.9 2.9-8.4 2.9c-5.4 0-10.5-2.9-10.5-12.6v-32.2h24.1v-18.2h-24.1v-23.8h-20.2v23.8h-15.7v18.1zm-83.5 49.2s12.7 14.5 36.1 14.5c20.4 0 34.9-11 34.9-24.6 0-16.5-11.3-21.8-27.2-25.1-13.5-2.9-18.9-4-18.9-8.9s6.9-7.6 14.5-7.6c10.8 0 19.9 6.9 19.9 6.9l10.1-14.8s-12-9.8-30-9.8c-21.9 0-34.4 12.5-34.4 25 0 15.2 13.8 21.9 29.7 25.3 12.1 2.5 15.8 3.5 15.8 8.8 0 4.9-6.9 7.2-15.2 7.2-13.5 0-24.1-11.5-24.1-11.5l-11.2 14.6zm-61.3 14.5c16.4 0 23.9-13.7 23.9-13.7v11.6h18.9v-79.9H1240v53.3s-5.4 9.8-15.8 9.8c-10.3 0-15.8-5.1-15.8-16.9v-46.2H1188v51.8c0 19.3 14 30.2 29.4 30.2m-100-94.6 17.7 46h-35.4l17.7-46zm-56.2 92.6h20.4l10.8-28h49.9l10.8 28h20.4l-45.9-118H1107l-45.8 118zm-121-19.2H922v-79.6h18.2c22.9 0 37.4 18.2 37.4 39.8 0 21.4-14.5 39.8-37.4 39.8m-.4-98.8h-38.1v118h38.1c34.4 0 58.3-25 58.3-59 .1-34.1-23.9-59-58.3-59m-89 118H871v-118h-20.2v118z" style="fill:#1d1d1b;"></path><path d="M628.7 234.5c-5.5-5.5-12.4-8.2-20.8-8.2s-15.4 2.9-21.2 8.6c-5.8 5.8-8.6 12.6-8.6 20.4 0 7.8 3 14.8 9 20.8s12.9 9 20.8 9 14.6-2.9 20.4-8.6c5.8-5.8 8.6-12.8 8.6-21.2 0-8.4-2.8-15.3-8.2-20.8zm85.1-26.3c-.3-16-6-29.5-16.9-40.4-11.2-11.2-25.2-16.9-42-16.9H498.8c-4.2 0-8.2 1-12.2 3.1-3.9 2.1-6.9 5-9 8.6L453.3 205h-77.7v35.3h83.9c4.2 0 8.2-1 12.2-3.1 3.9-2.1 6.9-5 9-8.6l24.3-42.4h143.6c8.4 0 15.4 2.9 21.2 8.6 5.8 5.8 8.6 12.8 8.6 21.2v124.7c0 8.4-2.9 15.4-8.6 21.2-5.8 5.8-12.8 8.6-21.2 8.6H505.9L462.7 296c-2.1-3.6-5.1-6.5-9-8.6-3.9-2.1-8-3.1-12.2-3.1h-65.9v35.3h59.6l42.4 73.7c2.1 3.7 5.1 6.7 9 9 3.9 2.3 8 3.5 12.2 3.5H655c16.7 0 30.7-5.6 42-16.9 10.9-10.9 16.5-24.3 16.9-40.4V209.8c-.1-.6-.1-1.1-.1-1.6z" style="fill:none;"></path><path d="M607.9 285.1c-7.8 0-14.8-3-20.8-9s-9-12.9-9-20.8c0-7.8 2.9-14.6 8.6-20.4 5.8-5.7 12.8-8.6 21.2-8.6 8.4 0 15.3 2.8 20.8 8.2 5.5 5.5 8.2 12.4 8.2 20.8s-2.9 15.4-8.6 21.2c-5.8 5.7-12.6 8.6-20.4 8.6z" style="fill:#5f7a8e;"></path><linearGradient id="a" x1="544.715" x2="544.715" y1="405.86" y2="150.92" gradientUnits="userSpaceOnUse"><stop offset="0" style="stop-color:#8ba3be;"></stop><stop offset="1" style="stop-color:#466272;"></stop></linearGradient><path d="M713.8 208.2v140.4c-.3 16.1-6 29.5-16.9 40.4-11.2 11.2-25.2 16.9-42 16.9H498.8c-4.2 0-8.2-1.2-12.2-3.5-3.9-2.4-6.9-5.4-9-9l-42.4-73.7h-59.6v-35.3h65.9c4.2 0 8.2 1.1 12.2 3.1 3.9 2.1 6.9 5 9 8.6l43.2 74.5h142.8c8.4 0 15.4-2.9 21.2-8.6 5.8-5.8 8.6-12.8 8.6-21.2V216c0-8.4-2.9-15.4-8.6-21.2-5.8-5.8-12.8-8.6-21.2-8.6H505.1l-24.3 42.4c-2.1 3.7-5.1 6.5-9 8.6-3.9 2.1-8 3.1-12.2 3.1h-83.9V205h77.7l24.3-42.4c2.1-3.7 5.1-6.5 9-8.6 3.9-2.1 8-3.1 12.2-3.1H655c16.7 0 30.7 5.6 42 16.9 10.8 10.9 16.4 24.4 16.8 40.4z" style="fill:url(#a);"></path><path d="m160.7 203.5 18.8 39.2h156.9v-39.2zm175.7 117.6v-39.2h-138l18.8 39.2z" style="fill:#e6320f;"></path></svg>
          </button>

          <button v-if="allowedTypes.includes('smartident')" @click="onInitiateSmartident" type="button" class="flex-1 flex items-center justify-center rounded-md border border-neutral-8 outline-none ring-0 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1178.17 218.33" class="h-10 w-auto"><path d="m255.68 141.82 10.1-7c2.5-1.7 4.5-1.2 6.4 1.4 6 7.9 19.4 16.7 35.7 16.7 17.3 0 23.3-6.4 23.3-16.5 0-12.4-21.5-16.1-31.6-19.4-10.7-3.3-42.5-9.1-42.5-36.3 0-25.8 22.3-36.9 48.5-36.9 21.5 0 39.6 10.7 46.6 22.7 1.4 2.5.4 4.7-1.9 6.2l-9.7 6.2c-2.5 1.5-4.5 1-6.4-1.4-5.4-6-17.1-12-31-12s-21.3 5.2-21.3 14.2c0 12 19.8 15.3 30.7 18.6 10.1 3.3 42.9 10.7 42.9 37.1s-19.4 39.2-49.7 39.2c-26.2 0-44.2-12.2-51.6-26.4-1.6-2.6-.8-4.7 1.5-6.4m248.9-24.29v50.1c0 2.9-1.7 4.7-4.7 4.7h-11.6c-2.9 0-4.7-1.7-4.7-4.7v-47.3c0-16.1-11.1-20.4-18.6-20.4s-18.4 4.3-18.4 20.4v47.3c0 2.9-1.7 4.7-4.7 4.7h-11.4c-2.9 0-4.7-1.7-4.7-4.7v-47.3c0-16.1-11.1-20.4-18.6-20.4s-18.4 4.3-18.4 20.4v47.3c0 2.9-1.7 4.7-4.7 4.7h-11.4c-2.9 0-4.7-1.7-4.7-4.7v-80c0-2.9 1.7-4.7 4.7-4.7h11.4c2.9 0 4.7 1.7 4.7 4.7v5c6.6-7.8 15.9-11.1 24.6-11.1 10.7 0 21.9 3.9 28.1 14.6 7.2-10.9 19.2-14.6 29.7-14.6 16.1.1 33.4 8.6 33.4 36m84.39 10.09c0-15.3-9.9-26.4-25.2-26.4s-25.4 11.1-25.4 26.4 10.1 26.6 25.4 26.6 25.2-11.3 25.2-26.6m4.6-44.6h11.4c2.9 0 4.7 1.7 4.7 4.7v79.9c0 2.9-1.7 4.7-4.7 4.7h-11.4c-2.9 0-4.7-1.7-4.7-4.7v-6.8c-6.2 7.9-15.7 13-28.1 13-24.8 0-42.9-19.6-42.9-46.2s18-46 42.9-46c12.4 0 21.9 4.9 28.1 13v-7c.1-2.9 1.8-4.6 4.7-4.6m80.4-1c3.1-.4 4.8 1.4 4.8 4.5v10.3c0 2.9-1.5 4.5-4.5 4.7-11.1 1.2-27 6.4-27 27.5v38.6c0 2.9-1.7 4.7-4.7 4.7h-11.4c-2.9 0-4.7-1.7-4.7-4.7v-80c0-2.9 1.7-4.7 4.7-4.7h11.4c2.9 0 4.7 1.7 4.7 4.7v11.4c6.5-10.6 16.4-15.6 26.7-17m61.81 16.9h-15.1v45.8c0 10.1 6.2 11.3 12 11.3h2.1c2.9 0 4.7 1.7 4.7 4.7v7c0 2.9-1.8 4.7-4.7 4.7h-10.5c-16.5 0-24.6-8.7-24.6-24.3v-49.1h-7.2c-2.9 0-4.7-1.8-4.7-4.7v-6.7c0-2.9 1.8-4.7 4.7-4.7h7.2v-22.7c0-2.9 1.7-4.7 4.7-4.7h11.6c2.9 0 4.6 1.7 4.6 4.7v22.7h15.1c2.9 0 4.7 1.7 4.7 4.7v6.6c.1 2.9-1.7 4.7-4.6 4.7m74.3 73.3h-12.2c-2.9 0-4.7-1.7-4.7-4.7V50.82c0-2.9 1.7-4.7 4.7-4.7h12.2c2.9 0 4.7 1.7 4.7 4.7v116.8c0 2.9-1.8 4.6-4.7 4.6m89.1-44.6c0-15.3-9.9-26.4-25.2-26.4s-25.4 11.1-25.4 26.4 10.1 26.6 25.4 26.6 25.2-11.3 25.2-26.6m4.6-81.5h11.5c2.9 0 4.7 1.7 4.7 4.7v116.8c0 2.9-1.7 4.7-4.7 4.7h-11.5c-2.9 0-4.7-1.7-4.7-4.7v-6.8c-6.2 7.9-15.7 13-28.1 13-24.8 0-42.9-19.6-42.9-46.2s18-46 42.9-46c12.4 0 21.9 4.9 28.1 13v-43.8c.1-2.9 1.8-4.7 4.7-4.7m50.1 73.91h47.5c-2.3-12.6-10.3-22.1-23.5-22.1s-21.7 8.7-24 22.1m66.9 7.6v1.2c0 2.9-1.8 4.7-4.7 4.7h-62.5c2.1 14 12 22.7 25.2 22.7 9.7 0 16.3-3.5 20.4-7.6 2.1-1.9 4.3-2.3 6.6-.6l6.8 5c2.5 1.9 2.9 4.1 1 6.4-8 9.1-20.4 14.5-34.7 14.5-27.2 0-45.4-19.8-45.4-46.4s17.5-46.2 44.4-46.2c26.2.1 42.9 19.7 42.9 46.3m95.6-10.1v50.1c0 2.9-1.7 4.7-4.7 4.7h-11.6c-2.9 0-4.7-1.7-4.7-4.7v-47c0-16.1-11.3-21.3-20.4-21.3s-20 5.2-20 21.3v47c0 2.9-1.7 4.7-4.7 4.7h-11.4c-2.9 0-4.7-1.7-4.7-4.7v-80c0-2.9 1.7-4.7 4.7-4.7h11.4c2.9 0 4.7 1.7 4.7 4.7v4.8c6.8-8 16.7-10.9 26.2-10.9 16.8.1 35.2 9.4 35.2 36m57.09-18.61h-15.1v45.8c0 10.1 6.2 11.3 12 11.3h2.1c2.9 0 4.7 1.7 4.7 4.7v7c0 2.9-1.8 4.7-4.7 4.7h-10.5c-16.5 0-24.6-8.7-24.6-24.3v-49.1h-7.2c-2.9 0-4.7-1.8-4.7-4.7v-6.7c0-2.9 1.8-4.7 4.7-4.7h7.2v-22.7c0-2.9 1.7-4.7 4.7-4.7h11.6c2.9 0 4.7 1.7 4.7 4.7v22.7h15.1c2.9 0 4.7 1.7 4.7 4.7v6.6c-.1 2.9-1.8 4.7-4.7 4.7" style="fill: rgb(76, 86, 99); stroke-width: 0;"></path><path d="m113.58 146.62-3.5-3.5c-.1-.1-.2-.3-.3-.4l-45.9-46c-16.2-16.2-16.2-42.5 0-58.7s42.5-16.2 58.7 0l50 49.9c2.5 2.5 5.3 2.3 7.8-.2l10.4-10.4c2.5-2.5 2.5-5.4 0-7.9l-49.9-49.7c-26.3-26.3-69.1-26.3-95.4 0-26.3 26.3-26.3 69.1 0 95.4l39.9 39.9 10.1 10.1c2.5 2.5 5.3 2.3 7.8-.2l10.4-10.4c2.4-2.5 2.4-5.5-.1-7.9Z" style="fill: rgb(217, 52, 137); stroke-width: 0;"></path><path d="m147.08 102.92-46-46s-.1 0-.1-.1l-3.8-3.8c-2.5-2.5-5.3-2.3-7.8.2l-10.4 10.4c-2.5 2.5-2.5 5.4 0 7.9l3.2 3.2c.2.2.3.4.5.6l46 46c16.2 16.2 16.2 42.6 0 58.8s-42.6 16.2-58.8 0l-49.7-49.7c-2.5-2.5-5.5-2.5-7.9 0l-10.4 10.4c-2.5 2.5-2.5 5.5 0 7.9l49.7 49.8c26.4 26.4 69.2 26.4 95.6 0 26.3-26.3 26.3-69.2-.1-95.6Z" style="fill: rgb(141, 179, 184); stroke-width: 0;"></path></svg>
          </button>
        </div>

        <iframe v-if="idAustriaIframeUrl && ! pending" :src="idAustriaIframeUrl" width="350" height="350" frameborder="0" class="mx-auto"></iframe>
      </template>

      <template v-else>
        <div v-if="qesInitiated">
          <p
            v-if="!theme.customDisclaimer"
            class="text-base text-neutral-1 rtl:text-right"
          >
            {{ $t("document.submit.description1") }}
            <span class="font-medium">{{
              $t("document.submit.description2Highlighted")
            }}</span>
            {{ $t("document.submit.description3") }}
          </p>

          <p
            v-else
            class="text-base text-neutral-1"
          >
            {{ theme.customDisclaimer }}
          </p>
        </div>

        <Loader
          v-if="!qesInitiated"
          :show-text="false"
          class="-mt-4 text-neutral-4"
        />

        <div v-else>
          <label
            for="otp"
            class="block mb-1 font-bold text-gray-700"
          >{{
            $t("qes.enterTAN")
          }}</label>
          <CodeInput v-model="otp" />

          <p
            v-if="!qesError"
            class="w-3/5 mt-2 text-xs text-gray-500"
          >
            {{
              $t("qes.tanSent", {
                phonenumber,
              })
            }}
          </p>
          <p
            v-if="qesError && qesError == 'wrong_otp'"
            class="w-2/3 mt-2 text-xs text-red-5"
          >
            {{ qesErrorText }}
          </p>
        </div>

        <div
          v-if="errors && errors.length"
          class="p-3 my-4 text-sm text-red-600 bg-red-100 border border-red-300 rounded "
        >
          <p
            v-for="(error, index) in errors"
            :key="index"
          >
            &raquo; {{ error[0] }}
          </p>
        </div>
      </template>
    </template>

    <template #buttons v-if="! pending && ! idAustriaIframeUrl">
      <BaseButton
        small
        outlined
        @click="$emit('onCancel')"
      >
        {{ $t("base.cancel") }}
      </BaseButton>

      <BaseButton
        small
        success
        v-if="smartidentInitiated"
        icon="fal fa-signature"
        :loading="pending || qesConfirming"
        :disabled="pending || qesConfirming || ! otpInputValid"
        @click="onSubmitOtp"
      >
        {{ $t("base.confirmSignature") }}
      </BaseButton>
    </template>
  </modal>
</template>

<script>
import { ref, onBeforeUnmount, computed, onMounted } from "vue";
import store from "@/store";
import setupEcho from "../../functions/setupEchoIdAustria";
import Modal from "../Common/Modal";
import apiClient from "./../../api"
import useQes from "./../../composables/useQes";
import useTheme from "./../../composables/LayoutAndStyle/useTheme";
import Loader from "./../../components/Common/Loader";
import VerificationQes from "./../../components/Verification/VerificationQes";
import CodeInput from "./../../components/Verification/CodeInput";

export default {
  components: {
    Modal,
    Loader,
    VerificationQes,
    CodeInput
  },
  props: {
    selectedDocuments: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  emits: ["onCancel", "onSubmit"],
  setup(props, { emit }) {
    const provider = ref(null);
    const { theme } = useTheme();
    const error = ref(null);
    const pending = ref(false);
    const otp = ref(null);
    const smartidentInitiated = ref(false);
    const idAustriaIframeUrl = ref(null);

    const allowedTypes = computed(() => store.state.auth.qes?.allowed_types || []);

    onMounted(() => {
      //onInitiateSmartident();
      
      if (allowedTypes.value.length == 1 && allowedTypes.value[0] == 'id_austria_atrust') {
        onInitiateIdAustria();
      } else {
        onInitiateSmartident();
      }


      /*if (allowedTypes.value.length == 1 && allowedTypes.value[0] == 'smartident') {
        onInitiateSmartident();
      }*/
    });

    onBeforeUnmount(() => {
      if (window.Echo) {
        window.Echo.leaveChannel(`mobilesign.${store.state.request.recipientId}`);
      }
    });

    function onInitiateIdAustria() {
      initiateEcho();
      error.value = null;
      provider.value = 'idaustria';
      pending.value = true;
      apiClient.post(`/requests/${store.state.request.requestId}/idaustria/initiate`, {
        documents: props.selectedDocuments.map(d => d.id),
      }).then(response => {
        pending.value = false;
        idAustriaIframeUrl.value = response.data.url;
      })
      .catch(e => {
          console.log(e);
      });
    }

    function initiateEcho() {
      setupEcho(store.state.request.requestId, store.state.auth.authToken);

      window.Echo.private(`idaustria.${store.state.request.recipientId}`).listen(
        "IdAustriaCallback", e => {
          console.log("IdAustriaCallback", e);
        }
      ).listen(
        "IdAustriaCallback2", e => {
          console.log("IdAustriaCallback2", e);
          pending.value = true;
        }
      ).listen(
        "IdAustriaCallbackError", e => {
          idAustriaIframeUrl.value = null;
          pending.value = false;
          error.value = e.error;
        }
      ).listen(
        "IdAustriaCallbackSuccess", e => {
          console.log("IdAustriaCallbackSuccess", e);
          store.commit("SET_LOADING", true);
          emit("onSubmit", true);
        }
      )
    }

    function onInitiateSmartident() {
      provider.value = 'smartident';
      smartidentInitiated.value = true;
      initiateQes();
    }

    const otpInputValid = computed(() => {
      return otp.value && otp.value.length === 6;
    });

    function onSubmitOtp() {
      confirmQes(otp, data => {
        store.commit("SET_LOADING", true);
        emit("onSubmit", true);
      }, props.selectedDocuments.map(d => d.id));
    }

    const {
      initiate: initiateQes,
      confirmMultiple: confirmQes,
      initiated: qesInitiated,
      confirming: qesConfirming,
      error: qesError,
      errorText: qesErrorText,
      phonenumber,
    } = useQes(store.state.request.request.recipient);

    return {
      onInitiateIdAustria,
      onInitiateSmartident,
      pending,
      idAustriaIframeUrl,
      smartidentInitiated,
      error,
      theme,
      otp,
      otpInputValid,
      phonenumber,
      qesInitiated,
      qesError,
      qesErrorText,
      qesConfirming,
      onSubmitOtp,
      allowedTypes,
    };
  },
};
</script>
